export const LEGAL = {
  siteName: 'FounderDNA',
  siteUrl: 'https://www.myfounderdna.com',
  contactEmail: 'hello@myfounderdna.com',
  privacyEmail: 'hello@myfounderdna.com',
  lastUpdated: 'July 2, 2026',
};

export const LEGAL_ROUTES = {
  privacy: '/privacy',
  terms: '/terms',
  cookies: '/cookies',
  contact: '/contact',
};
